<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    id="svg60"
    version="1.1"
    viewBox="-4.12599 -7.65905 35.75858 45.9543"
  >
    <defs id="defs38">
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="21.86"
        x2="-5.9"
        y1="1.87"
        x1="14.09"
        id="linear-gradient"
      >
        <stop id="stop4" stop-color="#008eff" offset="0" />
        <stop id="stop6" stop-color="#008fff" offset=".01" />
        <stop id="stop8" stop-color="#00acff" offset=".26" />
        <stop id="stop10" stop-color="#00c0ff" offset=".51" />
        <stop id="stop12" stop-color="#00cdff" offset=".76" />
        <stop id="stop14" stop-color="#00d1ff" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="15.32"
        x2="-2.37"
        y1="15.32"
        x1="26.45"
        id="linear-gradient-2"
      >
        <stop id="stop17" stop-color="#ffd800" offset="0" />
        <stop id="stop19" stop-color="#ff8a00" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="45.15"
        x2="-9.41"
        y1="18.05"
        x1="17.69"
        id="linear-gradient-3"
      >
        <stop id="stop22" stop-color="#ff3a44" offset="0" />
        <stop id="stop24" stop-color="#b11162" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="3.81"
        x2="8.92"
        y1="-8.29"
        x1="-3.19"
        id="linear-gradient-4"
      >
        <stop id="stop27" stop-color="#328e71" offset="0" />
        <stop id="stop29" stop-color="#2d9571" offset=".07" />
        <stop id="stop31" stop-color="#15bd74" offset=".48" />
        <stop id="stop33" stop-color="#06d575" offset=".8" />
        <stop id="stop35" stop-color="#00de76" offset="1" />
      </linearGradient>
    </defs>
    <g transform="translate(.004)" id="g58">
      <g id="g56">
        <path
          id="path40"
          d="M.55.48A2.39 2.39 0 000 2.15v26.34a2.41 2.41 0 00.55 1.67l.09.09 14.75-14.76v-.35L.64.39z"
          fill="url(#linear-gradient)"
        />
        <path
          id="path42"
          d="M20.31 20.41l-4.92-4.92v-.35l4.92-4.91.11.06 5.83 3.31c1.67.94 1.67 2.49 0 3.44l-5.83 3.31z"
          fill="url(#linear-gradient-2)"
        />
        <path
          id="path44"
          d="M20.42 20.35l-5-5L.55 30.16a2 2 0 002.45.07l17.39-9.88"
          fill="url(#linear-gradient-3)"
        />
        <path
          id="path46"
          d="M20.42 10.29L3 .4A1.93 1.93 0 00.55.48l14.84 14.84z"
          fill="url(#linear-gradient-4)"
        />
        <path
          id="path48"
          d="M20.31 20.24L3 30.06a2 2 0 01-2.39 0l-.09.09.09.09a2 2 0 002.39 0l17.39-9.88z"
          opacity=".1"
        />
        <path
          id="path50"
          d="M.55 30A2.43 2.43 0 010 28.32v.17a2.41 2.41 0 00.55 1.67l.09-.09z"
          class="cls-7"
        />
        <path
          id="path52"
          d="M26.25 16.86l-5.94 3.38.11.11L26.25 17a2.11 2.11 0 001.25-1.72 2.21 2.21 0 01-1.25 1.58z"
          class="cls-7"
        />
        <path
          id="path54"
          d="M3 .58l23.25 13.19a2.2 2.2 0 011.25 1.55 2.09 2.09 0 00-1.25-1.72L3 .4C1.36-.54 0 .24 0 2.15v.17C0 .42 1.36-.37 3 .58z"
          fill="#fff"
          opacity=".3"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "svgGoogleplay",
  props: {
    height: [String, Number],
    width: [String, Number],
  },
};
</script>

<style></style>
